export const TENANT_LOGIN_ERROR_QUERY_KEY = 'tenantLoginError'

export const TENANT_LOGIN_ERROR_CODES = {
  accessDenied: 'accessDenied',
  failed: 'failed',
}

const MESSAGE_KEYS = {
  [TENANT_LOGIN_ERROR_CODES.accessDenied]: 'clubSelector.tenantAccessDenied',
  [TENANT_LOGIN_ERROR_CODES.failed]: 'clubSelector.tenantLoginFailed',
}

export function getTenantLoginErrorMessageKey(errorCode) {
  return MESSAGE_KEYS[errorCode] || MESSAGE_KEYS[TENANT_LOGIN_ERROR_CODES.failed]
}
